/* eslint-disable */
import React, { useState, lazy, Suspense, useEffect, useCallback, useRef } from "react";
import * as protobuf from "protobufjs"
import "./arbitraje.css";
import { FaWindowRestore, FaCalculator, FaPause, FaPlay } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Ventana from "./Ventana";
import Main from "../../../layout/main";
import { useUserContext } from "../../../Providers/UserProvider";
import { io } from "socket.io-client";
import ValidateService from "../../../api/services/validateService";
// import Chat from "../../Chat/index";
//COMPONENTES
const Filtro = lazy(() => import("../../../Components/filtro/Filtro"));
const FiltroEspecial = lazy(() => import("../../../Components/filtro/FiltroEspecial"));
const Calculadora = lazy(() => import("../../../Components/caluladora/Calculadora"));
const HideSurebet = lazy(() => import("../../../Components/hide/HideSurebet"));
const Scanner = lazy(() => import("../../../Components/scanner/Scanner"));
const ScannerEspecial = lazy(() => import("../../../Components/scanner/ScannerFiltrado"));

//TOOLTIPS
const tooltip = (
    <Tooltip id="tooltip">
        <strong>Abrir en nueva ventana</strong>
    </Tooltip>
);
const tooltipF = (
    <Tooltip id="tooltipF">
        <strong>Solo ventanas flotantes</strong>
    </Tooltip>
);
const tooltipTC = (
    <Tooltip id="tooltipTC">
        <strong>Ver tipo de cambio</strong>
    </Tooltip>
);

function processSurebets(filtros, setDataSurebet, type) {
    // Mapeo de índices para el formato de array plano
    const fieldMapping = {
        typesurebet: 0,
        arbprofit: 1,
        middle: 2,
        sportname: 3,
        fulltime: 4,
        arbgenerationtime: 5,
        bookmaker: 6,
        currentscore: 7,
        eventname: 8,
        eventstarttime: 9,
        leaguename: 10,
        arboutcome: 11,
        directionodd: 12,
        odd: 13,
        created: 14,
        createddate: 15,
        arbid: 16,
        section: 17,
        color: 18,
        wrongitem: 19,
        origen: 20,
        tipo: 21
    };

    return (data) => {
        if (!data || !Array.isArray(data)) {
            //console.warn("Datos inválidos recibidos:", data);
            setDataSurebet([]);
            return;
        }

        // Verificar si los datos vienen en formato plano (array de arrays) o como objetos
        const isFlatArray = Array.isArray(data[0]) && !data[0].hasOwnProperty('typesurebet');

        // Convertir array plano a objetos con nombres de campos si es necesario
        let dataObjects = data;
        if (isFlatArray) {
            dataObjects = data.map(item => ({
                typesurebet: item[fieldMapping.typesurebet] || "",
                arbprofit: item[fieldMapping.arbprofit] || "0.00%",
                middle: item[fieldMapping.middle] || "",
                sportname: item[fieldMapping.sportname] || "",
                fulltime: item[fieldMapping.fulltime] || "",
                arbgenerationtime: item[fieldMapping.arbgenerationtime] || "",
                bookmaker: item[fieldMapping.bookmaker] || "",
                currentscore: item[fieldMapping.currentscore] || "",
                eventname: item[fieldMapping.eventname] || "",
                eventstarttime: item[fieldMapping.eventstarttime] || "",
                leaguename: item[fieldMapping.leaguename] || "",
                arboutcome: item[fieldMapping.arboutcome] || "",
                directionodd: item[fieldMapping.directionodd] || "",
                odd: item[fieldMapping.odd] || "1.00",
                created: item[fieldMapping.created] || "",
                createddate: item[fieldMapping.createddate] || "",
                arbid: item[fieldMapping.arbid] || "",
                section: item[fieldMapping.section] || "",
                color: item[fieldMapping.color] || "",
                wrongitem: item[fieldMapping.wrongitem] || "",
                origen: item[fieldMapping.origen] || "",
                tipo: item[fieldMapping.tipo] || ""
            }));
        }

        // FILTRANDO POR DEPORTES
        const datafilterSport = dataObjects.filter((elem) =>
            filtros.deportes.find(({ value, checked }) =>
                elem.sportname.toLowerCase() == String(value).toLowerCase() && checked
            )
        );

        // FILTRANDO POR CASAS
        const datafilter = datafilterSport.filter((elem) =>
            filtros.casas.find(({ value, checked }) => {
                // Dividir value por comas y verificar si el bookmaker coincide con alguno
                const valuesArray = value.split(',').map(v => v.trim());
                return valuesArray.includes(elem.bookmaker) && checked;
            })
        );

        // FILTRANDO POR INPUTS (PORCENTAJES)
        let perMin = filtros.inputs.percentMin != "" ? parseFloat(filtros.inputs.percentMin) : null;
        let perMax = filtros.inputs.percentMax != "" ? parseFloat(filtros.inputs.percentMax) : null;

        const dataFiltradazo = datafilter.filter((casas) => {
            let percent = parseFloat(casas.arbprofit.replace('%', ''));
            if (filtros.inputs.percentMin != "") {
                if (filtros.inputs.percentMax != "") {
                    if (perMin <= percent && percent <= perMax) {
                        return casas;
                    }
                } else {
                    if (perMin <= percent) {
                        return casas;
                    }
                }
            } else {
                if (filtros.inputs.percentMax != "") {
                    if (percent <= perMax) {
                        return casas;
                    }
                } else {
                    return casas;
                }
            }
        });

        // FILTRANDO POR INPUTS (ODDS)
        let oddMin = filtros.inputs.oddsMin != "" ? parseFloat(filtros.inputs.oddsMin) : null;
        let oddMax = filtros.inputs.oddsMax != "" ? parseFloat(filtros.inputs.oddsMax) : null;
        const filterSports = dataFiltradazo.filter((casas) => {
            let odd = parseFloat(casas.odd);
            if (filtros.inputs.oddsMin != "") {
                if (filtros.inputs.oddsMax != "") {
                    if (oddMin <= odd && odd <= oddMax) {
                        return casas;
                    }
                } else {
                    if (oddMin <= odd) {
                        return casas;
                    }
                }
            } else {
                if (filtros.inputs.oddsMax != "") {
                    if (odd <= oddMax) {
                        return casas;
                    }
                } else {
                    return casas;
                }
            }
        });

        // ORDENAR por porcentaje de ganancia (de mayor a menor)
        filterSports.sort((s1, s2) => {
            const percent1 = parseFloat(s1.arbprofit.replace('%', ''));
            const percent2 = parseFloat(s2.arbprofit.replace('%', ''));
            return percent2 - percent1;
        });

        let finalData = filterSports;

        // Recuperar los tags de ocultar ligas para el tipo actual
        const typeString = type === 2 ? "live" : "prematch";
        const tagsHideAll = JSON.parse(localStorage.getItem("tagsHideAll") || '{"live":[],"prematch":[]}');
        const tagsHide = tagsHideAll[typeString] || [];

        // Filtrar por coincidencia parcial en leaguename
        if (tagsHide.length > 0) {
            finalData = finalData.filter(item =>
                !tagsHide.some(tag =>
                    typeof item.leaguename === "string" &&
                    item.leaguename.toLowerCase().includes(tag.toLowerCase())
                )
            );
        }

        // SCANNER ESPECIAL - Agrupar por arbid
        const arbidMap = new Map();

        finalData.forEach(item => {
            const arbid = item.arbid;
            if (!arbidMap.has(arbid)) {
                arbidMap.set(arbid, []);
            }
            arbidMap.get(arbid).push(item);
        });

        // Solo mantener grupos con más de un elemento (apuestas complementarias)
        const datos = [];
        arbidMap.forEach((grupo, arbid) => {
            if (grupo.length > 1) {
                datos.push(grupo);
            }
        });

        // Filtrar surebets ocultos
        let datosHide = [];
        try {
            const key = type === 2 ? "hideEventsLive" : "hideEventsPrematch";
            const raw = localStorage.getItem(key);
            datosHide = raw ? JSON.parse(raw) : [];
        } catch (e) {
            datosHide = [];
        }

        let finalDatos = datos;
        if (Array.isArray(datosHide) && datosHide.length > 0) {
            finalDatos = filtrarArrays(datos, datosHide);
        }

        setDataSurebet((prev) => {
            if (Array.isArray(data) && data.length === 0 && Array.isArray(prev) && prev.length > 0) {
                return prev;
            }
            return finalDatos;
        });
    };
}

function filtrarArrays(arrayGeneral, arrayPequeno) {
    // Crear un conjunto de identificadores únicos para los elementos del array pequeño
    const identificadoresUnicos = new Set();

    // Recorrer el array pequeño y crear identificadores únicos basados en los campos especificados
    arrayPequeno.forEach(grupo => {
        grupo.forEach(item => {
            const identificador = `${item.typesurebet}_${item.sportname}_${item.bookmaker}_${item.eventname}_${item.leaguename}_${item.arboutcome}`;
            identificadoresUnicos.add(identificador);
        });
    });

    // Filtrar el array general
    return arrayGeneral.filter(grupo => {
        // Verificar si algún elemento del grupo coincide con los criterios
        const algunoCoincide = grupo.some(item => {
            const identificador = `${item.typesurebet}_${item.sportname}_${item.bookmaker}_${item.eventname}_${item.leaguename}_${item.arboutcome}`;
            return identificadoresUnicos.has(identificador);
        });

        // Si alguno coincide, eliminamos todo el grupo
        return !algunoCoincide;
    });
}

const Arbitraje = () => {
    //HOOKS
    const { user, filtrosLive, filtrosPrematch } = useUserContext();
    const [liveSure, setLiveSure] = useState([]);
    const [hideSure, setHideSure] = useState([]);
    const [dataSurebet, setDataSurebet] = useState([])
    const [dataSurebetPre, setDataSurebetPre] = useState([])
    const [dataFilter, setDataFilter] = useState([])
    const [type, setType] = useState(2);
    const [tc, setTc] = useState("normal");
    const [stake, setStake] = useState(user.stake);
    const [userTc, setUserTc] = useState(user.tipocambio);
    const [onlyF, setOnlyF] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [mood, setMood] = useState(false);
    const [disInput, setDisInput] = useState(true);
    const [trigger, setTrigger] = useState(0);
    const [showWindowPortal, setShowWindowPortal] = useState(false);
    const [pause, setPause] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [schemaLoaded, setSchemaLoaded] = useState(false)
    const [schemaError, setSchemaError] = useState(null)
    
    // Refs para valores estables que no deben causar re-renders
    const surebetListProtoRef = useRef(null)
    const socketRef = useRef(null);
    const currentTypeRef = useRef(2);
    const isMountedRef = useRef(true);
    const accessTokenRef = useRef(localStorage.getItem("accessToken"));
    const refreshTokenRef = useRef(localStorage.getItem("refreshToken"));
    const isConnectingRef = useRef(false); // Flag para evitar conexiones simultáneas

    useEffect(() => {
        setIsFirstLoad(true);
    }, [type]);

    useEffect(() => {
        let isMounted = true;
        let retryCount = 0;
        const maxRetries = 3;

        const loadProtobufSchema = async () => {
            try {
                const protoUrl = "https://socketsdev.ccacorps.com/proto/surebet.proto"; // Quitar espacios
                let protoText;

                // Intentar obtener el esquema con reintentos
                while (retryCount < maxRetries) {
                    try {
                        const response = await fetch(protoUrl);
                        if (response.ok) {
                            protoText = await response.text();
                            break;
                        }
                    } catch (error) {
                        //console.warn(`Intento ${retryCount + 1} fallido:`, error);
                    }
                    retryCount++;
                    await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
                }

                if (!protoText) {
                    throw new Error("No se pudo cargar el esquema Protobuf después de varios intentos");
                }

                const root = protobuf.parse(protoText, { keepCase: true }).root;
                if (isMounted) {
                    surebetListProtoRef.current = root.lookupType("surebet.SurebetList");
                    setSchemaLoaded(true);
                    setSchemaError(null);
                }
            } catch (error) {
                //console.error("Error loading Protobuf schema:", error);
                if (isMounted) {
                    setSchemaError(error.message || "Error al cargar el esquema Protobuf");
                }
            }
        };

        loadProtobufSchema();

        return () => {
            isMounted = false;
        };
    }, []); // Dependencias vacías para ejecutar solo una vez al montar

    const decodeSurebet = useCallback((data) => {
        if (!surebetListProtoRef.current || !data) {
            return null
        }

        try {
            let buffer

            if (data && data.type === 'protobuf' && data.data) {
                const binaryString = atob(data.data)
                const bytes = new Uint8Array(binaryString.length)
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i)
                }
                buffer = bytes
            } else if (data instanceof ArrayBuffer || data instanceof Uint8Array) {
                buffer = new Uint8Array(data)
            } else if (Array.isArray(data)) {
                buffer = new Uint8Array(data)
            } else {
                null
            }

            const decodedData = surebetListProtoRef.current.decode(buffer)
            const object = surebetListProtoRef.current.toObject(decodedData, {
                longs: String,
                enums: String,
                bytes: String
            })

            return object.items || []
        } catch (error) {
            //console.error("Error decoding Protobuf data:", error)
            return null
        }
    }, []);

    // Efecto ÚNICO para manejar la conexión del socket - Solo reconecta cuando cambia el tipo
    useEffect(() => {
        // Evitar múltiples conexiones simultáneas
        if (isConnectingRef.current) {
            return;
        }

        // Solo intentar conectar si tenemos el esquema y el token
        if (!accessTokenRef.current || !schemaLoaded) {
            return;
        }

        isConnectingRef.current = true;

        // Limpiar conexión anterior si existe
        if (socketRef.current) {
            const eventOff = currentTypeRef.current === 1 ? "prematch:off" : "live:off";
            socketRef.current.emit(eventOff);
            socketRef.current.removeAllListeners();
            socketRef.current.disconnect();
            socketRef.current = null;
        }

        socketRef.current = io("https://socketsdev.ccacorps.com", {
            path: "/socket1/",
            query: {
                variable: type,
                token: accessTokenRef.current,
            },
            reconnection: false, // DESACTIVAR reconexión automática
            transports: ['polling', 'websocket'],
            forceNew: true, // Forzar nueva conexión
        });

        currentTypeRef.current = type;
        const eventOn = type === 1 ? "prematch:on" : "live:on";
        
        // Handler de mensajes
        const messageHandler = (data) => {
            if (!isMountedRef.current || pause) return;
            
            let decodedData = null;
            if (surebetListProtoRef.current) {
                decodedData = decodeSurebet(data);
            }

            const useData = decodedData || data;
            
            const reduceSurebets = processSurebets(
                type === 2
                    ? JSON.parse(localStorage.getItem("filtrosLive") || "[]")
                    : JSON.parse(localStorage.getItem("filtrosPrematch") || "[]"),
                setDataSurebet,
                type
            );
            
            if (reduceSurebets) reduceSurebets(useData);
            
            if (isFirstLoad && isMountedRef.current) {
                setIsFirstLoad(false);
            }
        };

        socketRef.current.on(eventOn, messageHandler);
        
        // Esperar a que la conexión esté establecida antes de emitir
        socketRef.current.on("connect", () => {
            isConnectingRef.current = false;
            socketRef.current.emit(eventOn);
        });

        // Manejar desconexión (sin reconexión automática)
        socketRef.current.on("disconnect", (reason) => {
            isConnectingRef.current = false;
            // No hacer nada - dejar que el usuario cambie de pestaña o recargue
        });

        socketRef.current.on("connect_error", (error) => {
            isConnectingRef.current = false;
            // Error silencioso
        });

        // Manejar expiración de token desde el servidor
        socketRef.current.on("token-expired", (data) => {
            console.warn("Token expirado detectado por el servidor:", data);
            
            // Limpiar localStorage
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("userCca");
            
            // Desconectar socket
            if (socketRef.current) {
                socketRef.current.removeAllListeners();
                socketRef.current.disconnect();
                socketRef.current = null;
            }
            
            // Mostrar mensaje al usuario (opcional - usando Swal si está disponible)
            if (typeof Swal !== 'undefined') {
                Swal.fire({
                    title: 'Sesión Expirada',
                    text: data?.message || 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
                    icon: 'warning',
                    confirmButtonText: 'Aceptar'
                }).then(() => {
                    window.location.href = "/";
                });
            } else {
                alert(data?.message || 'Tu sesión ha expirado. Serás redirigido al login.');
                window.location.href = "/";
            }
        });

        // Cleanup - solo al cambiar tipo o desmontar
        return () => {
            isConnectingRef.current = false;
            if (socketRef.current) {
                const eventOff = type === 1 ? "prematch:off" : "live:off";
                socketRef.current.emit(eventOff);
                socketRef.current.removeAllListeners();
                socketRef.current.disconnect();
                socketRef.current = null;
            }
        };
    }, [type, schemaLoaded]); // SOLO estas 2 dependencias

    // Efecto para limpieza final al desmontar el componente
    useEffect(() => {
        isMountedRef.current = true;
        
        return () => {
            isMountedRef.current = false;
            if (socketRef.current) {
                socketRef.current.emit("live:off");
                socketRef.current.emit("prematch:off");
                socketRef.current.removeAllListeners();
                socketRef.current.disconnect();
                socketRef.current = null;
            }
        };
    }, []);

    const changeType = useCallback((tipo) => {
        setType(tipo);
        setIsFirstLoad(true); // Restablecer para primera carga del nuevo tipo
    }, []);

    const showScanner = useCallback((tipo) => {
        setShowFilter(tipo);
    }, []);

    const onOptionChange = (e) => {
        setTc(e.target.checked);
    };

    const openWindow = () => {
        setTrigger((trigger) => trigger + 1);
        setShowWindowPortal(true);
    };

    const closeWindowPortal = () => {
        setShowWindowPortal(false);
    };

    const onlyFloat = (e) => {
        var checkBox = document.getElementById("chck1");
        if (e.target.checked) {
            setOnlyF(true);
            setDisInput(true);

            if (checkBox.checked == true) {
                checkBox.checked = false;
                checkBox.disabled = true;
            }
        } else {
            setOnlyF(false);
            if (liveSure.length > 0) {
                setDisInput(false);
                if (checkBox.checked == false) {
                    checkBox.checked = true;
                    checkBox.disabled = false;
                }
            }
        }
    };

    const setData = (data) => {
        // dataLive = data
        setLiveSure(data);
        if (data.length != 0) {
            if (onlyF) {
                openWindow();
            } else {
                // console.log('aqui')
                setDisInput(false);
                var checkBox = document.getElementById("chck1");
                if (checkBox.checked == false) {
                    checkBox.checked = true;
                }
            }
        }
    };

    const setHideDatos = (data) => {
        setHideSure(data);
        $("#modal_hidesurebet").modal("show");
    }

    const setDatos = (data) => {
        setDataFilter(data)
    }

    const ToogleMood = useCallback((val) => {
        setMood(val);
    }, []);

    useEffect(() => {
        window.addEventListener("beforeunload", () => {
            closeWindowPortal();
        });
    }, []);

    const validation = async () => {
        const resp = await ValidateService.validateToken({ refreshToken: "Bearer " + refreshTokenRef.current });
    };

    useEffect(() => {
        validation();
    }, []);

    useEffect(() => {
        const interval = setInterval(async () => {
            await ValidateService.validateToken({ refreshToken: "Bearer " + refreshTokenRef.current });
        }, 1000 * 30);
        return () => clearInterval(interval);
    }, []);

    return (
        <Main userStake={(datos) => setStake(datos)} userTC={(datos) => setUserTc(datos)}>
            <Suspense
                fallback={
                    <div className="py-6 d-flex justify-content-center align-items-center h-100">
                        <h1>Cargando...</h1>
                    </div>
                }
            >
                <div className="row w-100 mx-auto" style={{ marginTop: "-10px" }}>
                    <div className="col-md-6 col-sm-12 order-2 order-md-1 h-100">
                        <div className="card ">
                            <div className="d-flex flex-column flex-xl-row header_tabs_scanner rounded justify-content-between align-items-center">
                                <div className="d-flex w-100 w-xl-auto justify-content-start align-items-center">
                                    <button
                                        className={`btn btn-evento w-100 btn-sm ${type == 2 ? "tabs_active_sca" : "text-white"}`}
                                        onClick={() => changeType(2)}
                                    >
                                        LIVE
                                    </button>
                                    <button
                                        className={`btn btn-evento w-100 btn-sm ${type == 1 ? "tabs_active_sca" : "text-white"}`}
                                        onClick={() => changeType(1)}
                                    >
                                        PREMATCH
                                    </button>
                                </div>

                                <div className="px-4 d-flex">
                                    <button className="btn btn-sm btn-outline-warning p-0 px-2" onClick={() => setPause(!pause)}>
                                        {
                                            pause ? <FaPlay size={16} className="text-white"></FaPlay> : <FaPause size={16} className="text-white"></FaPause>
                                        }
                                    </button>
                                    <Filtro type={type == 2 ? "live" : "prematch"} />
                                    <button
                                        type="button"
                                        className="btn btn-filtro btn-sm py-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModal1"
                                    >
                                        ESPECIALES
                                    </button>
                                    <div className="d-flex gap-2 justify-content-center align-items-center form-check form-switch form-check-custom form-check-primary form-check-solid">
                                        <input
                                            type="checkbox"
                                            className="form-check-input border_tc cursor-pointer"
                                            name="tipo_cambio"
                                            id="option-mood"
                                            value={mood}
                                            onChange={() => ToogleMood(!mood)}
                                        />
                                        <label htmlFor="option-mood" style={{ color: "white" }}>
                                            Normal/Resumido
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <ScannerEspecial
                                    actSurebet={user.pkgxd === 0 || user.statrefresh === 0 ? [] : dataSurebet}
                                    type={type}
                                    setFilterData={(datos) => setDatos(datos)}
                                    setLiveSure={(liveSure) => setData(liveSure)}
                                    setHideSure={(datos) => setHideDatos(datos)}
                                    mood={mood}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 order-1 order-md-2">
                        <div className="d-flex flex-column position-relative pb-3">
                            <div className={`d-flex flex-column position-relative calculadora_content pb-3 ${liveSure.length > 0 ? 'active' : ''}`}>
                                <div className="w-100 d-flex flex-column">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="tabs">
                                                <div className="tab">
                                                    <input type="checkbox" id="chck1" disabled={disInput} />
                                                    <label className="tab-label p-2" htmlFor="chck1">
                                                        <div className="d-flex box_options ps-5 gap-2 justify-content-between w-100 pe-5">
                                                            <div className="d-flex gap-2">
                                                                <div className="d-flex align-items-center cursor-pointer me-2">
                                                                    <FaCalculator size={15}></FaCalculator>
                                                                </div>
                                                                <OverlayTrigger placement="top" overlay={tooltipTC}>
                                                                    <div className="d-flex gap-2 justify-content-center align-items-center form-check form-switch form-check-custom form-check-primary form-check-solid">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input border_tc cursor-pointer"
                                                                            name="tipo_cambio"
                                                                            id="option-2"
                                                                            value={"tc"}
                                                                            onChange={onOptionChange}
                                                                        />
                                                                        <label htmlFor="option-2">TC</label>
                                                                    </div>
                                                                </OverlayTrigger>
                                                            </div>
                                                            <div className="d-flex gap-2">
                                                                <div className="form-check form-switch form-check-custom form-check-success form-check-solid me-2">
                                                                    <OverlayTrigger placement="top" overlay={tooltipF}>
                                                                        <input
                                                                            className="form-check-input ms-1 cursor-pointer"
                                                                            type="checkbox"
                                                                            value="1"
                                                                            id="flexSwitchDefault"
                                                                            onChange={onlyFloat}
                                                                        />
                                                                    </OverlayTrigger>
                                                                </div>

                                                                <OverlayTrigger placement="top" overlay={tooltip}>
                                                                    <button
                                                                        className=" btn btn-outline btn-outline-warning p-0 px-1"
                                                                        onClick={openWindow}
                                                                        aria-label="calculadora"
                                                                    >
                                                                        <FaWindowRestore></FaWindowRestore>
                                                                    </button>
                                                                </OverlayTrigger>
                                                            </div>
                                                        </div>
                                                    </label>
                                                    <div className="tab-content_cal card_contenido">
                                                        <Calculadora
                                                            actSurebet={liveSure}
                                                            tc={tc}
                                                            stake={stake}
                                                            userTc={userTc}
                                                            type={type}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <FiltroEspecial type={type == 2 ? "live" : "prematch"}></FiltroEspecial>
                    <HideSurebet surebet={hideSure} type={type}></HideSurebet>
                </div>
            </Suspense>
        </Main>
    );
};

export default Arbitraje;